import type { TScreenRotation } from '@/services/ScreenService'

/**
 * Returns Tailwind classes to position a fixed panel in a corner (0–3).
 * Used by CurrentState (status panel) and TimersOverlay (opposite corner).
 * Corner mapping for rotation '0': 0=bottom-right, 1=bottom-left, 2=top-left, 3=top-right.
 */
export function getCornerPositionClasses(corner: number, rotation: TScreenRotation): string {
  const base = 'fixed m-4'
  const c = corner % 4
  switch (rotation) {
    case '0':
      switch (c) {
        case 0: return `${base} bottom-0 right-0`
        case 1: return `${base} bottom-0 left-0`
        case 2: return `${base} top-0 left-0`
        case 3: return `${base} top-0 right-0`
        default: return `${base} top-0 left-0`
      }
    case '90':
      switch (c) {
        case 0: return `${base} rotate-90 bottom-0 right-0 origin-top-right translate-y-full`
        case 1: return `${base} rotate-90 bottom-0 left-0 origin-bottom-right -translate-x-full`
        case 2: return `${base} rotate-90 top-0 left-0 origin-bottom-left -translate-y-full`
        case 3: return `${base} rotate-90 top-0 right-0 origin-top-left translate-x-full`
        default: return `${base} rotate-90 top-0 left-0 origin-bottom-left -translate-y-full`
      }
    case '180':
      switch (c) {
        case 0: return `${base} rotate-180 top-0 left-0`
        case 1: return `${base} rotate-180 top-0 right-0`
        case 2: return `${base} rotate-180 bottom-0 right-0`
        case 3: return `${base} rotate-180 bottom-0 left-0`
        default: return `${base} rotate-180 top-0 left-0`
      }
    case '270':
      switch (c) {
        case 0: return `${base} -rotate-90 top-0 left-0 origin-top-right -translate-x-full`
        case 1: return `${base} -rotate-90 top-0 right-0 origin-bottom-right -translate-y-full`
        case 2: return `${base} -rotate-90 bottom-0 right-0 origin-bottom-left translate-x-full`
        case 3: return `${base} -rotate-90 bottom-0 left-0 origin-top-left translate-y-full`
        default: return `${base} -rotate-90 top-0 left-0 origin-top-right -translate-x-full`
      }
    default:
      return `${base} top-0 left-0`
  }
}
